const ENV = {
    DEVELOPMENT: {
        API_BASE_URL: 'http://192.168.1.36:5300'
    },
    PRODUCTION: {
        API_BASE_URL: window.location.origin + '/api'
    }
};

// Déterminer l'environnement en fonction de l'URL
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const currentEnv = isDevelopment ? ENV.DEVELOPMENT : ENV.PRODUCTION;

export default currentEnv; 